module.exports = __webpack_public_path__ + "static/media/vigo-green-bg.85f8df7b.svg";